import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Save, Landmark } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const inp = 'w-full h-9 text-sm border border-slate-200 rounded-lg px-3 bg-white focus:border-[#D4AF37] focus:outline-none';
const FIELDS = [
  ['bank_name', 'اسم البنك', 'Bank name', false],
  ['account_name', 'اسم صاحب الحساب', 'Account holder', false],
  ['iban', 'IBAN', 'IBAN', true],
  ['account_number', 'رقم الحساب', 'Account number', true],
  ['swift', 'SWIFT (اختياري)', 'SWIFT (optional)', true],
  ['phone', 'رقم الهاتف للتواصل', 'Contact phone', true],
  ['whatsapp', 'رقم واتساب', 'WhatsApp number', true],
  ['support_name', 'اسمك كما يظهر في الشات', 'Your name in chat', false],
  ['support_title', 'وصفك / منصبك في الشات (مثل: الموظف المختص - AZIZI.CO)', 'Your title in chat', false],
  ['turn_url', 'خادم TURN للمكالمات الصوتية (اختياري — يحسّن وصول الصوت عبر شبكات الجوال) مثال: turn:a.relay.metered.ca:80', 'TURN server URL (optional, improves voice call connectivity)', true],
  ['turn_username', 'اسم مستخدم TURN', 'TURN username', true],
  ['turn_credential', 'كلمة مرور TURN', 'TURN credential', true],
  ['chat_close_message', 'الرسالة الختامية التلقائية عند إنهاء المحادثة', 'Auto message sent when closing a chat', false],
];

export const BankSettings = ({ isRTL, headers }) => {
  const [f, setF] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(`${API}/app-settings`, { headers }).then(r => setF(r.data || {})).catch(() => {}); }, []);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const save = async () => {
    setSaving(true);
    try { const r = await axios.put(`${API}/app-settings`, f, { headers }); setF(r.data || {}); toast.success(isRTL ? 'تم حفظ بيانات الحساب' : 'Saved'); }
    catch (e) { toast.error(e.response?.data?.detail || (isRTL ? 'خطأ' : 'Error')); }
    setSaving(false);
  };
  return (
    <div className="space-y-4 max-w-2xl" data-testid="bank-settings">
      <div className="flex items-center gap-2 text-slate-600 text-sm"><Landmark className="w-4 h-4 text-[#D4AF37]" />{isRTL ? 'هذه البيانات تظهر للعميل/المتعامل عند إرسال طلب ليقوم بالتحويل عليها' : 'Shown to users when they submit a request so they can transfer payment'}</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {FIELDS.map(([k, ar, en, ltr]) => (
          <label key={k} className="block"><span className="text-[11px] font-semibold text-slate-500 mb-1 block">{isRTL ? ar : en}</span>
            <input className={inp} dir={ltr ? 'ltr' : undefined} value={f[k] || ''} onChange={e => set(k, e.target.value)} data-testid={`bank-${k}`} /></label>
        ))}
        <label className="block md:col-span-2"><span className="text-[11px] font-semibold text-slate-500 mb-1 block">{isRTL ? 'ملاحظة تظهر للعميل عند التحويل (عربي)' : 'Transfer note (AR)'}</span>
          <textarea className={`${inp} h-auto py-2 min-h-[60px]`} value={f.notes_ar || ''} onChange={e => set('notes_ar', e.target.value)} placeholder={isRTL ? 'مثال: يرجى كتابة اسم المنشأة في وصف التحويل' : ''} data-testid="bank-notes-ar" /></label>
        <label className="block md:col-span-2"><span className="text-[11px] font-semibold text-slate-500 mb-1 block">{isRTL ? 'ملاحظة (إنجليزي)' : 'Transfer note (EN)'}</span>
          <textarea className={`${inp} h-auto py-2 min-h-[60px]`} dir="ltr" value={f.notes_en || ''} onChange={e => set('notes_en', e.target.value)} /></label>
      </div>
      <Button onClick={save} disabled={saving} className="h-9 text-sm gap-1.5 bg-[#D4AF37] hover:bg-[#c4a030] text-white" data-testid="bank-save"><Save className="w-4 h-4" />{isRTL ? 'حفظ' : 'Save'}</Button>
    </div>
  );
};

export default BankSettings;
